const MODULE_NAME = 'ezresBontas';
export default angular.module(MODULE_NAME, [])
	.directive('ezresBontas', function ($filter) {
		'ngInject';
		return {
			restrict: 'A',
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				let tortSzam = attrs.ezresBontas;
				if (ngModel) {
					ngModel.$formatters.unshift(function () {			//convert data from model format to view format
						return $filter('number')(ngModel.$modelValue);
					});
					ngModel.$parsers.unshift(function (viewValue) {	//convert data from view format to model format
						let convertableNumber;
						let viewNumber;
						viewNumber = tortSzam ? viewValue.replace(/[^0-9|,]/g, '') : viewValue.replace(/[^0-9]/g, '');
						convertableNumber = viewValue;
						if ((viewNumber.match(/,/g) || []).length == 2) {
							viewNumber = viewNumber.slice(0, -1);
							convertableNumber = convertableNumber.slice(0, -1);
						}
						if (viewNumber.slice(-1) == ',') {
							convertableNumber = viewValue + '0';
						}
						convertableNumber = tortSzam ? convertableNumber.replace(/[^0-9|,]/g, '').replace(/,/g, '.').replace(/\s/g, '') : convertableNumber.replace(/[^0-9]/g, '').replace(/\s/g, '');
						var a = $filter('number')(convertableNumber);
						var b = (viewNumber.slice(-1) == ',') ? ',' : '';
						ngModel.$setViewValue(''+a +b) ;
						ngModel.$render();
						return convertableNumber;
					});
				}
			}
		};
	}).name;



// WEBPACK FOOTER //
// ./source/common/ezresbontas/ezresbontas.js